import React from 'react';
import { Button } from 'antd';

interface Props {
  userName: string;
  companyName: string;
  userEmail: string;
  onLogout: () => void;
}

const StepSuccess: React.FC<Props> = ({ userName, companyName, userEmail, onLogout }) => {
  const firstName = userName.split(' ')[0];

  return (
    <div style={{
      padding: '48px 32px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 16,
      maxWidth: 560,
      margin: '0 auto',
    }}>
      <svg width="220" height="160" viewBox="0 0 220 160" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="sg1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#EFE5FD" />
            <stop offset="1" stopColor="#F7F2FE" />
          </linearGradient>
        </defs>
        <rect x="0" y="110" width="220" height="2" fill="#E9ECF0" />
        <rect x="12" y="26" width="130" height="86" rx="12" fill="url(#sg1)" />
        <rect x="24" y="38" width="64" height="8" rx="4" fill="#D4B8FB" />
        <rect x="24" y="52" width="96" height="6" rx="3" fill="#EFE5FD" />
        <rect x="24" y="66" width="80" height="6" rx="3" fill="#EFE5FD" />
        <rect x="24" y="86" width="54" height="16" rx="8" fill="#5B00EF" />
        <circle cx="178" cy="70" r="34" fill="#5B00EF" />
        <path d="M164 72l10 10 18-22" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="42" cy="22" r="4" fill="#FF372D" />
        <circle cx="200" cy="24" r="3" fill="#FC850D" />
        <circle cx="14" cy="120" r="3" fill="#029B2D" />
        <path d="M196 118l6-12 6 12" stroke="#FC850D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

      <div>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#202020', marginBottom: 12 }}>
          Tudo certo, {firstName}!
        </h1>
        <p style={{ fontSize: 15, color: '#4c5462', lineHeight: 1.55, maxWidth: 440, margin: '0 auto' }}>
          Recebemos o cadastro da <strong style={{ color: '#202020' }}>{companyName || 'sua empresa'}</strong>.
          Nossa equipe vai analisar os dados em até{' '}
          <strong style={{ color: '#202020' }}>3 dias úteis</strong>.
          Quando estiver aprovado, enviaremos um e-mail para{' '}
          <span style={{
            fontFamily: 'monospace',
            color: '#3d009e',
            background: '#f7f2fe',
            padding: '1px 6px',
            borderRadius: 4,
            fontSize: '0.94em',
          }}>
            {userEmail}
          </span>{' '}
          com o link para entrar e cadastrar suas estações.
        </p>
      </div>

      <div style={{ marginTop: 8 }}>
        <Button
          type="primary"
          size="large"
          icon="logout"
          onClick={onLogout}
          style={{ background: '#5b00ef', borderColor: '#5b00ef', minWidth: 200 }}
        >
          Voltar ao início
        </Button>
      </div>

      <div style={{ fontSize: 13, color: '#6d7583', marginTop: 4 }}>
        Problemas no cadastro?{' '}
        <a href="mailto:suporte@tupimob.com" style={{ color: '#5b00ef' }}>
          Fale com o suporte
        </a>
      </div>
    </div>
  );
};

export default StepSuccess;
